// utils/formatNumber.ts
// export function formatNumber(value: number | string | null | undefined): string {
//     if (value === null || value === undefined || value === '') return '';
//     const number = typeof value === 'string' ? parseFloat(value) : value;
//     if (isNaN(number)) return '';
//     return number.toLocaleString('en-US'); // e.g. 1,500
//   }

export function formatNumber(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') return '';
    const number = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(number)) return '';
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(number); // e.g. $1,500.00
  }
  

// import { formatNumber } from "../../../Components/formatNumber/formatNumber";
